<template>
    <div v-if="currentUserIsAuthenticated">
      <form>
        <div class="form-group" :class="{'has-error': messageBodyHasError}" >
            <label for="messageBody" class="control-label f4 dn">
                Send Message
            </label>
            <textarea id="messageBody" v-model="message.body" maxlength="5000" rows="5" class="form-control ba b--black-10 bg-near-white br2"></textarea>
            <div class="red" v-if="messageBodyHasError">Please enter a message</div>
        </div>
        <vue-ladda button-class="ph4 white fw6 br2 w-100 bn pv3 bg-teal hover-bg-teal"
                   @click="sendMessage"
                   :loading="processing">
          Send Message
        </vue-ladda>

        <div v-if="messageSent" class="">
          <p class="mv3 f4 near-black lh-copy tc">Message Sent 👍 <a :href="conversationLink" class="teal hover-teal f4 tc fw6">View message</a></p>
          
        </div>
      </form>
    </div>
</template>

<script>
  import messagingService from '../../../../api/MessagingService'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'
  import VueLadda from '../../../shared-components/vue-ladda/'

  export default {
    name: 'MessageForm',
    components: {VueLadda},
    mixins: [validationMixin],
    props : {
      messageTo : {
        type: String,
        required: true,
      },
      currentUserIsAuthenticated : {
        type: Boolean,
        required: true
      }
    },
    data() {
      return {
        message : {
          to : {
            id: this.messageTo,
          },
          body : null,
        },
        messageSent: false,
        processing: false,
        conversationId : null,
      }
    },

    computed: {
      messageBodyHasError() {
        return this.$v.message.body.$dirty && this.$v.message.body.$invalid;
      },
      conversationLink(){
        return `/conversation/${this.conversationId}`;
      }
    },

    validations: {
      message: {
        to : {
          required,
        },
        body : {
          required,
          maxLength: maxLength(5000),
        }
      },
    },
    methods: {

      scrollToFirstError() {
        const firstError = _.head(this.$el.getElementsByClassName("has-error"));
        if(!_.isNil(firstError)){
          firstError.scrollIntoView();
        }
      },

      sendMessage(event) {
        event.preventDefault();

        // for validation
        this.$v.$touch();

        if(this.$v.$invalid) {
          this.$nextTick(() => this.scrollToFirstError());
        } else {

          this.processing = true;

          messagingService.sendMessageFromCurrentUserToProUser(this.message.to, this.message.body)
            .then(response => {
              this.conversationId = response.data;
              this.messageSent = true;
              this.message.body = '';
              this.$v.$reset();
            })
            .catch(error => {
              // handled
              console.log(error);
            })
            .then(() => {
              this.processing = false
            });
        }
      },
    },
  }
</script>

<!-- styles for this component -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/messaging/components/MessageForm.vue